module.exports = __webpack_public_path__ + "static/canyon-sunrise-zoom-7fd71101d395155a486420e9048608cc.jpg";